/*
* 组管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';

import Entity from './GroupEntity';
import GroupUserSetEntity from './GroupUserSetEntity.js';
import GroupAuthoritySetEntity from './GroupAuthoritySetEntity';

const Option = Select.Option;
const MODULENAME = CNF.navItems[2].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[2].ptn;

class Lists extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ulid: '',
            userOpen: false,
            authorityOpen: false,
            dataLists: this.props.dataLists,
        }
    }

    setUserOpen = (value) => { this.setState({ userOpen: value }); }
    setAuthorityOpen = (value) => { this.setState({ authorityOpen: value }); }
    update = (record) => { this.props.setIsModalOpen(true, record); }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.dataLists !== nextProps.dataLists) {
            this.setState({
                dataLists: nextProps.dataLists,
            })
        }
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    operation = (action, record) => {
        let uri = 'groups/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                this.update(record);
                break;
            case '账户' + CNF.actionName.SET:
                this.userSet(record);
                break;
            case '权限' + CNF.actionName.SET:
                this.authoritySet(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.groupname, action, MODULENAME, this.props.isRefresh, uri);
                break
            default:
                break;
        }
    }

    /**
     * 团队用户设置
     * @param {*} record 
     */
    userSet(record) {
        this.setState({
            record: record,
            userOpen: true,
        });
    }

    /**
     * 团队权限设置
     * @param {*} record 
     */
    authoritySet(record) {
        this.setState({
            record: record,
            authorityOpen: true,
        });
    }

    render() {
        const columns = [
            { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
            { title: '团队名', dataIndex: 'groupname', key: 'groupname', },
            { title: '显示名', dataIndex: 'displayname', key: 'displayname', },
            { title: '角色', dataIndex: 'rolename', key: 'rolename', },
            { title: '管理员', dataIndex: 'username', key: 'username', },
            { title: '描述', dataIndex: 'description', key: 'description', },
            { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
            { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
            {
                title: '', key: 'operation', width: CNF.tableOperationColumnWidth, hidden: (this.props.btnLists.indexOf(MODULENAME_PTN + '_user_set') >= 0 ||
                    this.props.btnLists.indexOf(MODULENAME_PTN + '_authority_set') >= 0 ||
                    this.props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                    this.props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                    this.props.btnLists.indexOf(MODULENAME_PTN + 'active') > 0 ||
                    this.props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0) ? false : true,
                render: (record) => GetDropdownActionName(this.props.btnLists, MODULENAME_PTN, record, this.operation)
            }
        ];
        return (
            <div>
                <Table
                    columns={columns}
                    size='middle'
                    dataSource={this.state.dataLists}
                    scroll={{ x: this.props.x }}
                    pagination={{
                        showSizeChanger: false,
                        // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                        showQuickJumper: false,
                        showTotal: () => `共${this.props.pageCount}条`,
                        pageSize: CNF.pageSize,
                        current: this.props.currentIndex,
                        total: this.props.pageCount,
                        onShowSizeChange: (current, pageSize) => this.props.changePageSize(pageSize, current),
                        onChange: (current) => this.props.changeIndex(current),
                    }}
                />
                <GroupUserSetEntity
                    record={this.state.record}
                    open={this.state.userOpen}
                    setOpen={this.setUserOpen}
                />
                <GroupAuthoritySetEntity
                    record={this.state.record}
                    open={this.state.authorityOpen}
                    setOpen={this.setAuthorityOpen}
                />
            </div>
        );
    }
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            isModalOpen: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            groupname: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeGroupname = (e) => { this.setState({ groupname: e.target.value.replace(/ /g, '') }); if (e.target.value.replace(/ /g, '') !== '') this.search(); }
    changeStatus = (value) => { this.setState({ status: value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setIsModalOpen = (value, record) => { this.setState({ isModalOpen: value, record: record }); }
    create = () => { this.setIsModalOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'groupname': this.state.groupname,
            'status': this.state.status === undefined ? '' : this.state.status,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}groups${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done(function (data) {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    _this.setState({
                        dataLists: data.dat,
                        pageCount: data.cnt
                    });
                } else {
                    _this.setState({
                        dataLists: [],
                        pageCount: 0
                    });
                }
            } else {
                message.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            message.error(data.responseJSON.detail, CNF.messageDuration);
        });
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <div>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeGroupname}
                            placeholder='团队名'
                            value={this.state.groupname}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            value={this.state.status}
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <Entity
                        btnLists={this.props.btnLists}
                        isModalOpen={this.state.isModalOpen}
                        record={this.state.record}
                        setIsModalOpen={this.setIsModalOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setIsModalOpen={this.setIsModalOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default CPT